import { useHookstate } from "@hookstate/core";
import { MAP_GLOBAL_STATES } from "globalStore/globalStore";
import React from "react";
import CurrentPage from "pages/Pace/Current";
import Settings from "pages/Pace/Settings";
import Reports from "./Reports";

export const Pace = () => { 
  const { mapSideNavTabState } = useHookstate(MAP_GLOBAL_STATES);
  if(window.innerWidth < 650){
    return <CurrentPage />;
  }else{
    switch (mapSideNavTabState.get()) {
      case "Current":
        return <CurrentPage />;
      case "Reports":
        return <Reports />;
      case "Settings":
        return <Settings />;
      default:
        return;
    }
  }
};
